// Copyright 1999-2026. WebPros International GmbH. All rights reserved.

import { Locale } from 'jsw';
import apolloClient from 'apolloClient';

import IIS_APP_POOL_CLIENT_SETTINGS_PAGE from 'queries/IisAppPoolClientSettingsPage.graphql';

export const iisAppPoolClientSettingsRoute = {
    path: 'client/:clientId/iis-app-pool/settings',
    componentLoader: () => import(
        /* webpackChunkName: "components/pages/IisAppPoolPage/IisAppPoolClientSettingsPage" */'components/pages/IisAppPoolPage/IisAppPoolClientSettingsPage'),
    loader: async ({ params }) => {
        const { data } = await apolloClient.query({
            query: IIS_APP_POOL_CLIENT_SETTINGS_PAGE,
            variables: { clientId: btoa(`Client:${params.clientId}`) },
        });

        if (!data.iisManager.appPoolSupported) {
            throw new Response('Not Found', { status: 404 });
        }

        return data;
    },
    handle: {
        helpContext: 'iisapppool',
        crumb: ({ data, params }) => {
            const locale = Locale.getSection('components.routes');
            const clientName = data?.client?.__typename === 'Client' ? data.client.name : '';

            return [
                {
                    title: locale.lmsg('iisAppPoolClientSettings', { client: `<b>${clientName}</b>` }),
                    href: `/cp/client/${params.clientId}/iis-app-pool/settings`,
                },
            ];
        },
    },
};
